import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_feeds_list = async (loadMore, slug, type) => {
  const requestObj = {
    path: `${loadMore}&search=${slug ? `&created_for=${slug}` : ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_new_feed = async (data) => {
  const requestObj = {
    path: `api/feed/add_feed`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const update_new_feed = async (data, id) => {
  const requestObj = {
    path: `api/feed/update/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_feeds_detail_api = async (loadMore, Id) => {
  const requestObj = {
    // path: `api/feed/detail/${Id}?page=${page}&limit=${limmit}`,
    path: `${loadMore}/${Id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const detail_feed_api = async (feed_id) => {
  const requestObj = {
    path: `api/feed/detail/${feed_id}`, // Correct URL structure
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const delete_feed = async (feed_id) => {
  const requestObj = {
    path: `api/feed/${feed_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const like_unlike_feed = async (id) => {
  const requestObj = {
    path: `api/feed/like_unlike_feed/${id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {},
  };
  return invokeApi(requestObj);
};

export const add_feed_comment = async (data) => {
  const requestObj = {
    path: `api/feed/add_feed_comment`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const update_feed_comment = async (data, id) => {
  const requestObj = {
    path: `api/feed/update_feed_comment/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const like_unlike_feed_comment = async (id) => {
  const requestObj = {
    path: `api/feed/like_unlike_feed_comment/${id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {},
  };
  return invokeApi(requestObj);
};

export const delete_comment_api = async (id) => {
  const requestObj = {
    path: `api/feed/delete_feed_comment/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_company_profile_by_id = async (Id) => {
  const requestObj = {
    path: `api/client/detail_client/${Id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
